import {
  reactive,
} from 'vue';

export const modalState = reactive({
  visible: false,
  props: {},
  component: null,
  componentProps: {},
  componentEvents: {},
  actions: [],
});

export function openModal(props = {}, component, componentProps = {}, componentEvents = {}, actions = []) {
  modalState.visible = true;
  modalState.props = props;
  modalState.component = component;
  modalState.componentProps = componentProps;
  modalState.componentEvents = componentEvents;
  modalState.actions = actions;
}

export function closeModal() {
  modalState.visible = false;
  modalState.props = {};
  modalState.component = null;
  modalState.componentProps = {};
  modalState.componentEvents = {};
  modalState.actions = [];
}